var exports = {
  "kL": "DMFriendsView.module__container___WW13d2",
  "Em": "DMFriendsView.module__mainColumn___WW13d2",
  "Qs": "DMFriendsView.module__content___WW13d2",
  "sf": "DMFriendsView.module__searchWrapper___WW13d2",
  "qc": "DMFriendsView.module__searchIcon___WW13d2",
  "MJ": "DMFriendsView.module__tabBody___WW13d2",
  "VW": "DMFriendsView.module__headerContent___WW13d2",
  "cP": "DMFriendsView.module__titleSection___WW13d2",
  "gr": "DMFriendsView.module__titleIcon___WW13d2",
  "Qw": "DMFriendsView.module__titleText___WW13d2",
  "yF": "DMFriendsView.module__divider___WW13d2",
  "me": "DMFriendsView.module__tabsWrapper___WW13d2",
  "xd": "DMFriendsView.module__tabsScroller___WW13d2",
  "VD": "DMFriendsView.module__tabsInner___WW13d2",
  "eg": "DMFriendsView.module__tabButton___WW13d2",
  "vu": "DMFriendsView.module__active___WW13d2",
  "zB": "DMFriendsView.module__primary___WW13d2",
  "Lj": "DMFriendsView.module__tabContent___WW13d2",
};

module.exports = exports;
